import Filter from '@elentari/components-eve/components/Filter'
import TextField from '@elentari/components-eve/final-form/TextField'
import { useQueryParams } from '@elentari/core'
import Grid from '@material-ui/core/Grid'
import * as dateFns from 'date-fns'
import * as yup from 'yup'
import FFMaskedInput from '../../components/Forms/FFMaskedInput'
import yupValidation from '../../utils/yupValidation'
import { MessagesYup } from '../messages'

const schema = yup.object().shape({
  descricao: yup.string().typeError(MessagesYup.MENSAGEM_CAMPO_STRING)
})

export type GrupoNegociadorQueryFilter = {
  createdAt?: { gt: string }
  [key: string]: any
}
export const GrupoNegociadorFilter = () => {
  const { clear, push, initialValues } =
    useQueryParams<GrupoNegociadorQueryFilter>()

  const handleSubmitFilter = (values: Record<string, any>) => {
    clear()
    push({
      ...values
    })
  }

  const format = (initialValues: GrupoNegociadorQueryFilter) => {
    if (initialValues.createdAt) {
      return {
        ...initialValues,
        createdAt: dateFns.format(
          dateFns.parseISO(initialValues.createdAt.gt),
          'dd/MM/yyyy'
        )
      }
    }
    return initialValues
  }

  return (
    <Filter
      labels={{
        clear: 'Limpar',
        find: 'Buscar'
      }}
      initialValues={format(initialValues)}
      onClear={clear}
      onSubmit={values => handleSubmitFilter({ ...values, page: 1 })}
      validate={yupValidation(schema)}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <TextField fullWidth name="codigo" label="Código" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth name="nome" label="Nome" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FFMaskedInput name="raizCnpj" label="Raiz CNPJ" mask="99.999.999" />
        </Grid>
      </Grid>
    </Filter>
  )
}
